import mongoose, { Schema } from 'mongoose';
import {
  always,
  applySpec,
  compose,
  converge,
  nthArg,
  propOr,
} from 'ramda';
import { string } from '@555platform/utility-belt.js';
import { renameObjectKeys } from '../util';
import { query as queryModel } from './util';

const fgcmSchema = new Schema({
  className: { type: String },
  readAccess: [String],
  writeAccess: [String],
  ownerID: { type: String },
  createAt: { type: Date },
  updatedAt: { type: Date },
  fields: {
    app_key: { type: String },
    app_domain_client_id: { type: String },
    app_domain: { type: String },
    gcm_api_key: { type: String },
  },
});

const applyFieldScope = string.createTemplate('fields.${}');

export const fgcm = () => mongoose.model(
  'fgcminfo',
  fgcmSchema,
  'FgcmInfo',
);

export const query = queryModel(fgcm);

fgcmSchema.statics.findByClientID = compose(
  query('findOne'),
  applySpec({
    'fields.app_key': nthArg(0),
    ownerID: nthArg(1),
  }),
);

const now = () => new Date();

fgcmSchema.statics.upsert = converge(query('findOneAndUpdate'), [
  applySpec({ 'fields:app_key': propOr('__', 'app_key') }),
  applySpec({
    updatedAt: now,
    $setOnInsert: { ownerID: nthArg(1), createdAt: now },
    $set: renameObjectKeys(applyFieldScope),
  }),
  always({
    upsert: true,
    setDefaultsOnInsert: true,
    new: true,
  }),
]);

export default fgcm;
